import React, { useEffect, useState } from "react";
import TXT from "presentational/common/multinational/TXT";
import CommonGuideTooltipView from "presentational/common/modals/CommonGuideTooltipView";

function ScrollDownTooltipView(props) {
  const { children } = props;
  const [needClose, setNeedClose] = useState(false);

  useEffect(() => {
    initEvent();
    return destroyEvent;
  }, []);

  const initEvent = () => {
    window.addEventListener("scroll", handleScroll);
  };

  const destroyEvent = () => {
    window.removeEventListener("scroll", handleScroll);
  };

  const handleScroll = () => {
    setNeedClose(true);
    window.removeEventListener("scroll", handleScroll);
  };

  return (
    <CommonGuideTooltipView
      needClose={needClose}
      needCountUp={false}
      message={<TXT name="msg_tooltipScrollDown" />}
      placement={"top-end"}
      backgroundDesign={"primary"}
      displayForGuest
      displayOnModal
    >
      {children}
    </CommonGuideTooltipView>
  );
}

export default ScrollDownTooltipView;
